interface PageTitleProps {
    title: string
}

export function PageTitle({ title }: PageTitleProps) {
    return (
        <div className="bg-orange-400 text-white mb-0.5 text-center"><span className="ml-1 font-medium text-lg">{title}</span></div>
    )
}